module.exports = __webpack_public_path__ + "static/media/img_donut.1d11e834.png";